import CashRegisterForm from './CashRegisterForm'
export {CashRegisterForm}
export default CashRegisterForm
